/**
 * Text intro parallax effect for floating images
 * Disabled on mobile devices for better performance
 */
jQuery(document).ready(function () {
  let $parallaxImages = jQuery(".text-intro-section .parallax-image");

  if (!$parallaxImages.length) {
    return;
  }

  let ticking = false;
  let lastScrollY = window.scrollY;
  let isMobile = window.innerWidth < 1280;

  function checkIfMobile() {
    isMobile = window.innerWidth < 1280;
    if (isMobile) {
      $parallaxImages.css("transform", "none");
    }
  }

  /**
   * Update parallax positions based on scroll (desktop only)
   */
  function updateParallax() {
    ticking = false;

    if (isMobile) {
      return;
    }

    let viewportHeight = window.innerHeight;
    let baseScroll = lastScrollY;

    $parallaxImages.each(function () {
      let $image = jQuery(this);
      let speed = parseFloat($image.data("speed")) || 0.2;

      let translateY = baseScroll * speed;
      let maxMove = viewportHeight * 0.5;
      if (translateY > maxMove) {
        translateY = maxMove;
      }

      $image.css("transform", "translate3d(0, " + translateY + "px, 0)");
    });
  }

  /**
   * Handle scroll events with throttling
   */
  function onScroll() {
    lastScrollY = window.scrollY;

    if (!ticking && !isMobile) {
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    }
  }

  checkIfMobile();
  updateParallax();

  jQuery(window).on("scroll", onScroll);

  jQuery(window).on("resize", function () {
    checkIfMobile();
    updateParallax();
  });
});
